import React from 'react';

export default function SidebarCizimler() {
  return (
        <div className='row'>
            <div className="col-12">
                <div className='sideBarFormTitle'>
                    Çizim
                </div>
            </div>
            <div className='col-12'>
                <b></b>
            </div>
            <div className='col-12'>
                <b></b>
            </div>
        </div>
  );
}
